





















































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import allTrain from "@/views/train/allTrain.vue";
import myTrain from "@/views/train/myTrain.vue";
import trainMap from "@/views/train/trainMap.vue";
import util from "@/lib/util";
import ShortHeaderLayout from "@/layouts/shortHeaderLayout.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import DescriptionList from "@/components/DescriptionList/DescriptionList.vue";
import DescriptionListItem from "@/components/DescriptionList/DescriptionListItem.vue";
import SectionLayout from "@/layouts/sectionLayout.vue";
import AppConsts from "@/lib/appconst";

/*0：字符，1日期时间，2整数，3选择序列，4手机号，5电子邮箱，6文件TOOD,7姓名，8证件号,9浮点数*/
enum TRAIN_FORM_ITEM_TYPE {
  char = 0,
  time,
  integer,
  list,
  phone,
  email,
  file,
  name,
  id,
  float
}


@Component({
  components: {SectionLayout, ShortHeaderLayout, basicPage, DescriptionList, DescriptionListItem, trainMap}
})
export default class applyTrain extends basicPage {
  @Prop({type: String, default: ''}) trainId: string;
  @Prop({type: String, default: ''}) trainName: string;
  @Prop({type: String, default: ''}) trainState: string;

  formItemLayout = {
    labelCol: {span: 6},
    wrapperCol: {span: 18},
  };

  form: any;
  formItems: any = [];
  data: any = [];
  tableData: any = [];
  tabPage = false;
  formItemType = TRAIN_FORM_ITEM_TYPE;
  hasHeight = false;
  routeTokens: any = {};

  defRoutes = [{
    path: 'train',
    breadcrumbName: '培训报名',
  }]

  rowSelection = null;

  tableColumn = []


  //加载申请用户信息
  loadApplyUser() {
    ajaxHelperInstance.get('/web/meeting/search/getSingUpList/' + this.trainId, {
      page: 1,
      pageSize: 1000,
      isQueryUser: true,
    }).then((res) => {
      let {data, errno, message} = res.data;
      let dataAll = (data == null ? [] : data.dataAll);
      this.tableData = [];
      if (errno != 0) {
        return;
      }

      _.each(dataAll, (val, ind) => {
        let tmp = {id: ind}
        _.each(val, (formItem, ind2) => {
          tmp[formItem.bmx] = formItem.value;
        })
        this.tableData.push(tmp);
      })
      // console.log(data);
    })
  }

  loadData() {
    let self = this;
    ajaxHelperInstance.get('web/meeting/model/getModelFormInfo', {pxid: this.trainId}).then((res) => {
      let {data, errno, message} = res.data;
      self.formItems = data;
      self.tableColumn = [];
      _.each(data, (val) => {
        self.tableColumn.push({
          title: val.bmx,
          dataIndex: val.bmx,
          ellipsis: true,
          width: 180
        });
      })
      self.tableColumn.push(
          {
            title: '操作',
            dataIndex: 'cz',
            scopedSlots: {customRender: 'cz'},
            fixed: 'right',
            width: 120
          },
      )

      this.loadApplyUser();
      // console.log(data);
    })
  }

  mounted() {


    this.routeTokens = {
      'pxtitle': this.trainName
    }
    // this.defRoutes.push({
    //     path: `trainDetail/${this.trainId}`,
    //     breadcrumbName: this.trainName,
    // });
    //
    // this.defRoutes.push({
    //     path: `/trainApply`,
    //     breadcrumbName: '我要报名',
    // });

    this.loadData();

  }

  beforeCreate() {
    this.form = this.$form.createForm(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      let repData = values;
      if (!repData.id) {
        repData.id = util.getGuid();
      }

      let pdTable = [...this.tableData];
      let index = _.findIndex(pdTable, {id: repData.id});
      if (index >= 0) {
        pdTable[index] = repData;
      } else {
        pdTable.push(repData);
      }
      this.tableData = pdTable;
      this.form.resetFields();
    })
  }

  isInputCtrl(lx) {
    /*0：字符，1日期时间，2整数，3选择序列，4手机号，5电子邮箱，6文件TOOD,7姓名，8证件号,9浮点数*/

    lx = parseInt(lx);

    let arr = [
      TRAIN_FORM_ITEM_TYPE.char, TRAIN_FORM_ITEM_TYPE.phone, TRAIN_FORM_ITEM_TYPE.email,
      TRAIN_FORM_ITEM_TYPE.name, TRAIN_FORM_ITEM_TYPE.id, TRAIN_FORM_ITEM_TYPE.integer,
      TRAIN_FORM_ITEM_TYPE.float
    ];
    return _.includes(arr, lx);
  }

  formValidator(rule, value, callback) {

    let {field, fullField, type} = rule;
    let item = _.find(this.formItems, {bmx: field});
    if (!item) {
      callback()
    }
    let bmxlx = parseInt(item.bmxlx);
    /*0：字符，1日期时间，2整数，3选择序列，4手机号，5电子邮箱(yjr-已修改)，6文件TOOD,7姓名，8身份证号（yjr-已修改）,9浮点数*/
    let validtors = {
      0: /[\s\S]+/, //随便写的
      1: /[\s\S]+/, //随便写的，等于没验证
      2: /^\d+$/,
      3: /[\s\S]+/, //随便写的
      4: /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/,
      5: /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/,
      6: /[\s\S]+/,
      7: /[\s\S]+/, //就是不计算
      8: /^[1-9]\d{5}((((19|[2-9][0-9])\d{2})(0?[13578]|1[02])(0?[1-9]|[12][0-9]|3[01]))|(((19|[2-9][0-9])\d{2})(0?[13456789]|1[012])(0?[1-9]|[12][0-9]|30))|(((19|[2-9][0-9])\d{2})0?2(0?[1-9]|1[0-9]|2[0-8]))|(((1[6-9]|[2-9][0-9])(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))0?229))\d{3}[0-9Xx]$/,
      9: /^\d+.{1}\d+$/
    }
    let regPattern = validtors[bmxlx];
    var patt1 = new RegExp(regPattern);
    if (value && !patt1.test(value)) {
      if (bmxlx == 0) {
        callback(new Error("字段验证不通过"));
      } else if (bmxlx == 1) {
        callback(new Error("字段验证不通过"));
      } else if (bmxlx == 2) {
        callback(new Error("请输入整数"));
      } else if (bmxlx == 3) {
        callback(new Error("字段验证不通过"));
      } else if (bmxlx == 4) {
        callback(new Error("请输入正确的手机号"));
      } else if (bmxlx == 5) {
        callback(new Error("请输入正确的邮箱"));
      } else if (bmxlx == 6) {
        callback(new Error("字段验证不通过"));
      } else if (bmxlx == 7) {
        callback(new Error("字段验证不通过"));
      } else if (bmxlx == 8) {
        callback(new Error("请输入正确的身份证号"));
      } else if (bmxlx == 9) {
        callback(new Error("请输入浮点数"));
      }
      //  callback(new Error("字段验证不通过"));
    }

    callback()
  }

  deleteItem(id) {
    let list = [...this.tableData];
    _.remove(list, {id: id});
    this.tableData = list;
  }

  //通过报名项获取报名类型
  getBmlxById(bmx) {
    let item = _.find(this.formItems, {bmx: bmx});
    return item.bmxlx;
  }

  submitData() {
    let tmpList = [];
    _.each(this.tableData, (val, ind) => {
      _.each(val, (val2, key) => {
        if (key == 'id') {
          return;
        }
        tmpList.push({
          id: val.id,
          pxidfk: this.trainId,
          // bmrid: '652700',
          bmx: key,
          bmxlx: this.getBmlxById(key),
          value: val2
        })
      })
    })

    let rdata = JSON.stringify(tmpList);

    if (rdata == "[]" || rdata == undefined || rdata == null) {
      this.$message.error("先录入报名信息");
      return;
    }
    ajaxHelperInstance.postD('/web/meeting/operation/addsignUp', rdata, undefined, undefined, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      let {data, errno, message} = res.data;
      if (errno != 0) {
        this.$message.info(message);
        return;
      } else {
        this.$message.info("提交成功!");
      }
    })
  }


  getListItem(item) {
    return item.split(':');
  }

  editItem(record) {
    util.setFormValue(this.form, record);
    console.log(record);
  }

}
